import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Box } from "@mui/material";
import LiveMatchBroadcastSection from "../components/LiveMatch/LiveMatchBroadcastSection";
import ResultBadge from "../components/Home/ResultBadge"

function LiveMatchPage() {
  const { match_id } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [match_id]);

  return (
    <>
      <Helmet>
        <title>Live Match | SAAC Basketball Quito 2026</title>
        <meta
          name="description"
          content="Watch the live basketball match with real-time score updates from SAAC Basketball Quito 2026."
        />
      </Helmet>

      <Box
        component="main"
        sx={{
          backgroundColor: "#f8fafc",
          minHeight: "100vh",
        }}
      >
        <LiveMatchBroadcastSection />
        <ResultBadge />
      </Box>
    </>
  );
}

export default LiveMatchPage;